// Company contact config
export const PHONE = "+91 76968 99983";
export const PHONE2 = "+91 9815262813";
export const WHATSAPP_NUMBER = "917696899983";
export const EMAIL = "shreeramagroindustries2024@gmail.com";
export const ADDRESS = "Phase-7, Focal Point, Near Ashoka Kanda, Village Gobindgarh, Ludhiana, Punjab — 141010";
export const FACEBOOK_URL = "https://www.facebook.com/people/Shree-Ram-Agro/61559215610423/";
export const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_NUMBER}?text=Hello%20sir%2C%20I%20am%20interested%20in%20your%20agriculture%20machinery.`;
export const CALL_LINK = `tel:${PHONE.replace(/\s/g, "")}`;

export const INDIAN_STATES = [
  "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh",
  "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand", "Karnataka",
  "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur", "Meghalaya", "Mizoram",
  "Nagaland", "Odisha", "Punjab", "Rajasthan", "Sikkim", "Tamil Nadu",
  "Telangana", "Tripura", "Uttar Pradesh", "Uttarakhand", "West Bengal",
  "Delhi", "Jammu & Kashmir", "Chandigarh", "Ladakh"
];
